import "./Pulse.css"
import React from 'react'
import Window from "./Window"

import { observer, inject } from "mobx-react"

const Pulse = ({color, style})=> {
  return <div className="Pulse" style={style}>
    <svg version="1.2" height="300" width="600">
      <path 
        stroke="rgba(15,0,0,0.1)" 
        fill="none" 
        strokeWidth="1" 
        strokeLinejoin="round"
        d="M0,90L250,90Q257,60 262,87T267,95 270,88 273,92t6,35 7,-60T290,127 297,107s2,-11 10,-10 1,1 8,-10T319,95c6,4 8,-6 10,-17s2,10 9,11h210" 
      />   
      <path
        id="pulsar"
        stroke={color}
        fill="none" 
        strokeWidth="1"
        strokeLinejoin="round"
        d="M0,90L250,90Q257,60 262,87T267,95 270,88 273,92t6,35 7,-60T290,127 297,107s2,-11 10,-10 1,1 8,-10T319,95c6,4 8,-6 10,-17s2,10 9,11h210" 
      /> 
    </svg>
  </div>
}

const PulseWindow = ({app})=> {
  const title = <span>00110000 00110001</span>
  return <Window title={title} width={300} height={250} className="PulseWindow">
    <div className="Pulse__wrap">
      { app.profiles.map( (p,i)=> <Pulse key={i} color={p.color} style={{ top: i*10 }}  /> ) }
    </div>
  </Window>
}

export default inject(["app"])(observer(PulseWindow))


// WEBPACK FOOTER //
// ./src/components/Pulse.js